export default "__VITE_ASSET__0oU2scJO__"